import React from 'react';
import { Container, Card, CardBody, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract, faFilePdf, faDownload } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import esm from "./../../assets/Disability pension.pdf";
import esm1 from "./../../assets/Gallantry Award.pdf";
import esm2 from "./../../assets/Haryana_CAPF_Policy_for_Ex-Gratia_Grant_on_Disability.pdf";

const policyData = [
  { title: 'Disability Pension', link: esm },
  { title: 'Honours and Awards', link: esm1 },
  { title: 'Haryana CAPF Policy for Ex-Gratia Grant on Disability', link: esm2 },
];

const Policy = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faFileContract} className="me-2" />
            CAPF Policies
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faFileContract} className="me-2" />
              Policy Documents
            </h4>
          </div>
          <CardBody className="p-4">
            <ListGroup flush>
              {policyData.map((policy, index) => (
                <ListGroupItem 
                  key={index} 
                  className="py-3 px-0 border-bottom"
                  style={{ borderColor: '#e9ecef' }}
                >
                  <a 
                    href={policy.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                  >
                    <div style={{
                      background: 'rgba(30,60,114,0.1)',
                      color: '#1e3c72',
                      padding: '10px 15px',
                      borderRadius: '8px',
                      marginRight: '15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minWidth: '30px',
                      fontWeight: '600'
                    }}>
                      {index + 1}
                    </div>
                    <div className="flex-grow-1">
                      <strong style={{ color: '#1e3c72', fontSize: '1rem' }}>{policy.title}</strong>
                    </div>
                    <div style={{
                      background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                      color: 'white',
                      padding: '8px 20px',
                      borderRadius: '20px',
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <FontAwesomeIcon icon={faDownload} />
                      View
                    </div>
                  </a>
                </ListGroupItem>
              ))}
            </ListGroup>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default Policy